import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider.js'
import RegulationTagsDt from '@/services/dataTransferModules/regulationTagsDt'

export default function useRegulationTags(params = {}) {
	const regulationTagsDt = new RegulationTagsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingRegulationTags: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: regulationTags,
		getEntities: getRegulationTags,

		createEntity: createRegulationTags,

		entity: regulationTag,
		getEntity: getRegulationTag,

		patchEntity: updateRegulationTags,
		updateEntity: fullUpdateRegulationTags,

		entityPreview: regulationTagsPreview,
		getEntityPreview: getRegulationTagsPreview,

		deleteEntity: deleteRegulationTags,
	} = useBlProviders(
		regulationTagsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Regulation tag loading error'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Error adding tag'),

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error while editing regulation tag'),

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		regulationTags,
		regulationTagsPreview,
		regulationTag,
		defaults,
		getRegulationTags,
		getRegulationTagsPreview,
		getRegulationTag,
		createRegulationTags,
		deleteRegulationTags,
		updateRegulationTags,
		fullUpdateRegulationTags,
	}
}
